module.exports = __webpack_public_path__ + "media/Instruction_6.dc3787eb.mp3";